class QueryStringHandler {

  constructor(queryString){
    this.queryString = queryString;
  }

  extract(type){
    if (!this.queryString.hasOwnProperty(type+'[]')) {
      return [];
    }

    if (Array.isArray(this.queryString[type+'[]'])) {

      return this.queryString[type+'[]'].map(el => {
        return this.isInteger(el) ? parseInt(el) : el
      });
    }

    let segment = this.queryString[type+'[]'];
    let ret = (this.isInteger(segment) ? parseInt(segment) : segment);
    return [ret];
  }

  isInteger(el) {
    let regex = RegExp(/^\d+$/);
    return regex.test(el);
  }

  formatForJs(el){
    if (this.isInteger(el)) return parseInt(el);
    return el;
  }

}

export default QueryStringHandler;
